// extracted by mini-css-extract-plugin
export default {"headline":"_2aHUo","title":"_3aGMr"};